import { render, staticRenderFns } from "./ReportCollectionDetails_EIBIC.vue?vue&type=template&id=2a912d58&scoped=true&"
import script from "./ReportCollectionDetails_EIBIC.vue?vue&type=script&lang=js&"
export * from "./ReportCollectionDetails_EIBIC.vue?vue&type=script&lang=js&"
import style0 from "./ReportCollectionDetails_EIBIC.vue?vue&type=style&index=0&id=2a912d58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a912d58",
  null
  
)

export default component.exports